import React, { forwardRef, SFC, SVGProps } from 'react'
import clsx from 'clsx'

import styles from './style.module.scss'
import ConditionalRender from 'utils/conditionalRender'
import Icon from '@material-ui/core/Icon'
import XIcon from '../XIcon'

interface Props {
    children?: any
    fontSize?: string
    fontWeight?: any
    fontFamily?: any
    icon?: string
    customIcon?: SFC<SVGProps<SVGSVGElement>>
    size?: string
    type?: string
    href?: string
    marginTop?: number
    target?: string
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

const XLink = forwardRef<any, Props>((props: Props, ref) => {
    const { children, size, href, type, icon, customIcon, target, onClick } = props

    return (
        <a
            href={href}
            className={clsx(styles.xlink, styles[size], icon ? 'xlink__icon' : null, styles[type])}
            style={{
                fontSize: props.fontSize || 'inherit',
                fontWeight: props.fontWeight || 'inherit',
                fontFamily: props.fontFamily || 'inherit',
            }}
            target={target ? target : '_blank'}
            onClick={onClick}
        >
            {children}
            <ConditionalRender if={icon}>
                <Icon>{icon}</Icon>
            </ConditionalRender>
            <ConditionalRender if={customIcon}>
                <XIcon size={28} tintColor="primaryColor" icon={customIcon}></XIcon>
            </ConditionalRender>
        </a>
    )
})

XLink.displayName = 'XLink'
export default XLink
